import { Role } from "../types";

export const NEW_ATHLETE_ROLES: Role[] = ["athlete"];
